<template>
    <div class="crmappBusinessContiner">
        <div class="crmappBusinessContiner-contract">
            <div class="crmappBusinessContiner-contract-text">1、参与活动的用户将免费获得1份最高价值100万元交通出行保险，具体详情以保险公司承保短信或邮件为准</div>
            <div class="crmappBusinessContiner-contract-text">2、每位用户限领1份赠险，多次领取无效，且只能为本人领取</div>
            <div class="crmappBusinessContiner-contract-text">3、本活动仅限25-50岁参与，不在该年龄范围内将无法领取</div>
            <div class="crmappBusinessContiner-contract-text">
                4、保险期限：本保险的保障期限为（1-6）个月不等，以被保险人收到短信通知上的保险起止日期为准。对保险起至日期之外所发生的保险事故本公司不负给付保险金责任</div>
            <div class="crmappBusinessContiner-contract-text">
                5、保险凭证：本产品仅提供电子保单，仅限赠送。保单经审核生效后客户会自动收到短信通知，请将短信保存并将短信上的电子保单号记录在适当的位置，以方便查询及理赔</div>
            <div class="crmappBusinessContiner-contract-text">6、本保险不接受撤保、退保、加保及被保险人更换</div>
            <div class="crmappBusinessContiner-contract-text">7、保险理赔：请妥善保管电子保单号，以便理赔及查询，此赠险不可受理任何变更，理赔时请提供该保单号</div>
            <div class="crmappBusinessContiner-contract-text">8、 如有疑问，可咨询客服qq： 2013780348</div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'contract',
    props: {
        userA: {//甲方
            type:String,
            default:''
        },
        popuTime:{//协议时间
            type:String,
            default:''
        },
        readContract: {
            type:Boolean,
            default:true
        },
        showContract: {
            type:Boolean,
            default:true
        }
    },
    data(){
        return{
            showView:this.showContract
        }
    },
    watch:{
        showView(val){
            this.$emit('update:showContract',val);
        },
        showContract(val){
            this.showView = val;
        }
    },
    methods: {
        showContractClick() {
            this.$emit('showContractClick');
        }
    }
}
</script>

<style lang="less">
.crmappBusinessContiner{
    &-contract{
        margin: 0px 10px 10px 10px;
        overflow-y: auto;
        color: gray !important;
        &-text{
            font-size: 10px;
            margin-top: 5px;
            text-indent: 2em;
        }
        &-sort-title{
            margin-top: 5px;
            margin-bottom: 5px;
            font-size: 14px;
            text-align: center;
        }
    }
}

</style>
